export var ModeTypes;
(function (ModeTypes) {
    ModeTypes[ModeTypes["duel"] = 1] = "duel";
    ModeTypes[ModeTypes["clubDuel"] = 2] = "clubDuel";
    ModeTypes[ModeTypes["tutorial"] = 3] = "tutorial";
    ModeTypes[ModeTypes["dailyLeague"] = 4] = "dailyLeague";
    ModeTypes[ModeTypes["bossCompetition"] = 5] = "bossCompetition";
    ModeTypes[ModeTypes["eventBossFight"] = 6] = "eventBossFight";
    ModeTypes[ModeTypes["tournament"] = 7] = "tournament";
    ModeTypes[ModeTypes["legend"] = 8] = "legend";
    ModeTypes[ModeTypes["taskTraining"] = 9] = "taskTraining";
    ModeTypes[ModeTypes["taskTrainingTrainer"] = 10] = "taskTrainingTrainer";
    ModeTypes[ModeTypes["wsm2021easy"] = 11] = "wsm2021easy";
    ModeTypes[ModeTypes["wsm2021medium"] = 12] = "wsm2021medium";
    ModeTypes[ModeTypes["wsm2021hard"] = 13] = "wsm2021hard";
    ModeTypes[ModeTypes["tutorialFromTrainingHall"] = 14] = "tutorialFromTrainingHall";
})(ModeTypes || (ModeTypes = {}));
//# sourceMappingURL=modes.js.map